module.exports = "<sui-nav [nav]='nav'> </sui-nav>\r\n\r\n<div class=\"sui-container\">\r\n    <router-outlet></router-outlet>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 409
// module chunks = 0